export default {
  // Nav
  'nav.services': '服务项目',
  'nav.cases': '成功案例',
  'nav.about': '关于我们',
  'nav.contact': '联系我们',
  'nav.cta': '免费咨询',

  // Hero
  'hero.tag': '/ 区块链全周期发行专家',
  'hero.title.line1': '让数字产品',
  'hero.title.line2': '安全登陆链上',
  'hero.subtitle': '锐角40 Angle Forty 专注为数字产品提供安全、可靠的区块链发行与部署服务，涵盖规划、发行、运营、优化的全周期解决方案。',
  'hero.cta.primary': '启动您的链上部署',
  'hero.cta.secondary': '查看服务详情',
  'hero.stat.projects': '已部署项目',
  'hero.stat.chains': '支持公链',
  'hero.stat.uptime': '平均可用率',
  'hero.stat.experts': '技术专家',

  // Marquee
  'marquee.item1': 'ETHEREUM · 以太坊',
  'marquee.item2': 'SOLANA · 索拉纳',
  'marquee.item3': 'BNB CHAIN · 币安链',
  'marquee.item4': 'POLYGON · 多边形',
  'marquee.item5': 'ARBITRUM · 二层网络',
  'marquee.item6': 'BASE · 基础链',
  'marquee.item7': 'AVALANCHE · 雪崩链',

  // About
  'about.tag': '/ 公司概述',
  'about.title': '从规划到优化，全周期链上护航',
  'about.desc': '锐角40 Angle Forty 由来自区块链核心协议、金融科技与产品运营领域的资深团队组建，服务全球超过 120 个数字产品项目安全上链。我们相信优秀的链上部署，不仅是一次发布，更是产品生命周期的长期陪伴。',
  'about.number': '01',
  'about.number.label': '全周期链上服务框架',
  'about.number.desc': '从市场调研、Tokenomics 设计、智能合约部署，到产品分发、数据监测与持续优化，四大阶段无缝衔接，让客户专注于产品本身。',
  'about.cta': '了解服务框架',

  // Services
  'services.tag': '/ 核心服务',
  'services.title.line1': '区块链发行',
  'services.title.line2': '数据监测运营',
  'services.desc': '四大阶段，一体化交付。从策略规划到长期优化，每一步都由专属团队护航。',
  'services.s1.title': '规划咨询',
  'services.s1.desc': '深入分析产品定位、目标链与代币经济模型，制定可执行的链上发行路线图。',
  'services.s1.tag': 'Phase 01',
  'services.s2.title': '链上部署',
  'services.s2.desc': '智能合约审计、多链部署、安全防护，确保每一笔交易与资产都可靠可追溯。',
  'services.s2.tag': 'Phase 02',
  'services.s3.title': '产品运营',
  'services.s3.desc': '产品分发、社群运营、内容策略与活动策划，助力项目高效触达目标用户。',
  'services.s3.tag': 'Phase 03',
  'services.s4.title': '技术支持',
  'services.s4.desc': '7×24 监测预警、数据分析仪表板与持续优化，让项目穿越市场周期。',
  'services.s4.tag': 'Phase 04',
  'services.s.badge.hot': '热门',

  // Cases
  'cases.tag': '/ 成功案例',
  'cases.title': '被信赖的链上伙伴',
  'cases.desc': '聚焦 NFT 数字藏品发行全链路，从艺术创作到链上部署的一站式实战案例。',
  'cases.viewAll': '查看全部案例',
  'cases.c1.name': 'Pixel Origin',
  'cases.c1.category': 'NFT · 艺术品首发平台',
  'cases.c1.tvl': '发行额 2,800 ETH',
  'cases.c2.name': 'Vault Society',
  'cases.c2.category': 'NFT · 会员通行证',
  'cases.c2.tvl': '铸造量 15,000+',
  'cases.c3.name': 'MetaForge',
  'cases.c3.category': 'NFT · 游戏资产',
  'cases.c3.tvl': '交易量 1,200 万美元',
  'cases.c4.name': 'Eden Drop',
  'cases.c4.category': 'NFT · 发行市场',
  'cases.c4.tvl': '月活 28 万',

  // Testimonial
  'testimonial.tag': '/ 客户评价',
  'testimonial.quote': '锐角40 让我们在 6 周内完成了原本预计半年的多链部署，数据仪表板让运营团队第一次真正看清了链上业务。',
  'testimonial.author': 'Yvonne Liao',
  'testimonial.role': 'Pixel Origin 联合创始人',
  'testimonial.verified': '已验证合作',

  // CTA
  'cta.tag': '/ 立即咨询',
  'cta.title': '准备好开启您的链上之旅了吗？',
  'cta.desc': '留下您的项目信息，资深顾问将于 24 小时内与您联系，为您规划专属部署方案。',
  'cta.form.name': '您的姓名',
  'cta.form.email': '联系邮箱',
  'cta.form.company': '公司 / 项目名称',
  'cta.form.type': '项目类型',
  'cta.form.type.nft.art': 'NFT 艺术品 / 数字藏品',
  'cta.form.type.nft.gaming': 'NFT 游戏资产',
  'cta.form.type.nft.membership': 'NFT 会员 / 实用型',
  'cta.form.type.nft.marketplace': 'NFT 市场 / 发行平台',
  'cta.form.type.other': '其他',
  'cta.form.message': '简述您的项目与需求（500 字以内）',
  'cta.form.submit': '立即发送咨询',
  'cta.form.submitting': '发送中…',
  'cta.form.success': '感谢您的咨询！我们将于 24 小时内联系您。',
  'cta.form.error': '提交失败，请稍后再试或直接发送邮件至 hello@angleforty.com',

  // Footer
  'footer.brandDesc': '锐角40 Angle Forty · 让每一个数字产品都能安全、优雅地登陆区块链。',
  'footer.nav.title': '快速导航',
  'footer.contact.title': '联络信息',
  'footer.social.title': '关注我们',
  'footer.newsletter': '订阅动态',
  'footer.newsletter.desc': '每月一封，只发送深度行业洞察与案例复盘。',
  'footer.newsletter.placeholder': '输入您的邮箱',
  'footer.newsletter.button': '订阅',
  'footer.address.title': '办公地址',
  'footer.address.value': '香港中环皇后大道中9号',
  'footer.phone': '+852 3150 0000',
  'footer.email': 'hello@angleforty.com',
  'footer.copyright': '© 2026 Angle Forty Technology Ltd. 保留所有权利。',
  'footer.policy.privacy': '隐私政策',
  'footer.policy.terms': '服务条款',

  // Language
  'lang.zh-Hant': '繁中',
  'lang.zh-Hans': '简中',
  'lang.en': 'EN',
  'lang.ja': '日文',
  'lang.ko': '한국어',
};